/* tslint:disable */
/* eslint-disable */
/**
 * Referentials API
 * API for managing referentials, including countries, civility titles, and nationalities.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ReferentialDto } from './ReferentialDto';
import {
    ReferentialDtoFromJSON,
    ReferentialDtoFromJSONTyped,
    ReferentialDtoToJSON,
    ReferentialDtoToJSONTyped,
} from './ReferentialDto';

/**
 * 
 * @export
 * @interface ReferentialResponseDto
 */
export interface ReferentialResponseDto {
    /**
     * 
     * @type {Array<ReferentialDto>}
     * @memberof ReferentialResponseDto
     */
    referential?: Array<ReferentialDto>;
}

/**
 * Check if a given object implements the ReferentialResponseDto interface.
 */
export function instanceOfReferentialResponseDto(value: object): value is ReferentialResponseDto {
    return true;
}

export function ReferentialResponseDtoFromJSON(json: any): ReferentialResponseDto {
    return ReferentialResponseDtoFromJSONTyped(json, false);
}

export function ReferentialResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReferentialResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'referential': json['referential'] == null ? undefined : ((json['referential'] as Array<any>).map(ReferentialDtoFromJSON)),
    };
}

export function ReferentialResponseDtoToJSON(json: any): ReferentialResponseDto {
    return ReferentialResponseDtoToJSONTyped(json, false);
}

export function ReferentialResponseDtoToJSONTyped(value?: ReferentialResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'referential': value['referential'] == null ? undefined : ((value['referential'] as Array<any>).map(ReferentialDtoToJSON)),
    };
}

